import { AddMetadata, BlockKeys } from '../BlockCatalog';
import { BlockParameters, PipelineBlock } from '../PipelineBlock';
import { PipelineStage } from '../Stage';
import CloudCoverageStage, { CloudCoverageStageParams } from '../stages/transformations/CloudCoverageStage';
import DiffuseRadiationStage, { DiffuseRadiationStageParams } from '../stages/transformations/DiffuseRadiationStage';
import { StageContext } from '../Context';
import { PipelinePhase } from '@visualizer/types';

export interface SolarParamsBlockParameters extends BlockParameters, CloudCoverageStageParams, DiffuseRadiationStageParams {}

@AddMetadata({
    type: BlockKeys.SolarParameters,
    name: 'Solar Parameters',
    description: 'Applies cloud coverage and/or diffuse radiation to current sensors',
    unique: true,
    pipelinePhase: PipelinePhase.Pre,
    visible: false,
})
class SolarParamsBlock extends PipelineBlock<SolarParamsBlockParameters> {
    constructor(params: SolarParamsBlockParameters, id?: string) {
        super(params, id);
    }

    protected override defineStages(): PipelineStage<any>[] {
        return [
            new CloudCoverageStage({
                isCloudCoverOn: this.getParams().isCloudCoverOn,
                cloudCoverPercentage: this.getParams().cloudCoverPercentage,
            }),
            new DiffuseRadiationStage({
                isDiffuseRadiationOn: this.getParams().isDiffuseRadiationOn,
                diffuseRadiationPercentage: this.getParams().diffuseRadiationPercentage,
            }),
        ];
    }

    // Update min/max to have a consistent SPs coloring & legend:
    protected override executeStages(stages: PipelineStage<any>[], context: StageContext): StageContext {
        const output = super.executeStages(stages, context);

        const cloudFactor = this.getParams().isCloudCoverOn ? 1 - this.getParams().cloudCoverPercentage : 1;
        const diffuseFactor = this.getParams().isDiffuseRadiationOn ? 1 + this.getParams().diffuseRadiationPercentage : 1;
        const factor = cloudFactor * diffuseFactor;

        const baseMin = context.absoluteMinMax[0];
        const baseMax = context.absoluteMinMax[1];

        const updatedMinMax: [number, number] = [baseMin * factor, baseMax * factor];

        return {
            ...output,
            remappedMinMax: updatedMinMax,
            absoluteMinMax: updatedMinMax,
        };
    }
}

export default SolarParamsBlock;
